import renderFactfinderFeedback from './templates/factfinder-feedback.tpl.html';
import {delay, stringToHTML} from "../general/Util";

class FactfinderFeedback {
	static insertAfterPosition = 12;
	static aftersearchContentInjectedEventName = 'aftersearch_content_injected.sl';

	constructor( containerEl ) {
		this.containerEl = containerEl;

		document.addEventListener( FactfinderFeedback.aftersearchContentInjectedEventName, () => this.onInsert() );

		this.containerEl.addEventListener( 'click', ( ev ) => {
			this.containerEl.removeEventListener( FactfinderFeedback.aftersearchContentInjectedEventName, this.onInsert );
			const feedbackEl = containerEl.querySelector( '.mdl_factfinder_aftersearch_feedback' );
			const buttonEl = ev.target.closest( '.mdl_factfinder_aftersearch_feedback__trigger' );
			if ( buttonEl ) {
				if ( feedbackEl.classList.contains( 'is-voted' ) ) {
					return;
				}

				feedbackEl.classList.add( 'is-voted' );
				buttonEl.classList.add( 'is-selected' );

				const params = new URLSearchParams( window.location.search );
				let dataLayer = window.dataLayer || [];

				dataLayer.push( {
					"event": "afterSearchFeedback",
					"asScore": buttonEl.getAttribute( 'data-feedback-score' ),
					"asTerm": params.get( 'query' ),
				} );

				delay( 300 ).then( () => {
					feedbackEl.querySelector( '.mdl_factfinder_aftersearch_feedback__thankyou' ).classList.remove( 'en_hidden' );
					return delay( 2500 );
				} ).then( () => {
					feedbackEl.classList.add( 'is-closing' );
					return delay( 400 );
				} ).then( () => {
					feedbackEl.remove();
				} )
			}
		} );
	}

	onInsert() {
		EN.Render.render( 'factfinder-feedback' ).then( ( feedbackStr ) => {
			const feedbackEl = stringToHTML( feedbackStr );
			// Get all Elements in list to get correct index.
			const productAndTileEls = this.containerEl.querySelectorAll( 'article.en_mdl_product, figure.en_mdl_productlisttile' );
			const targetEl = productAndTileEls[ FactfinderFeedback.insertAfterPosition ] ?? null;
			if ( targetEl ) {
				targetEl.insertAdjacentElement( 'beforebegin', feedbackEl );
			}
		} );
	}
}

EN.Render.addTemplate( 'factfinder-feedback', renderFactfinderFeedback );

export default FactfinderFeedback;
